import { useCallback, useEffect, useState } from 'react';
import { fetchConToken } from '../helpers/fetch';

export function useCrmIndicators({ funnelId, text = '', prospectType = '', revision = 0, period = 'all' }) {
    const [refreshKey, setRefreshKey] = useState(0);
    const [state, setState] = useState({ data: null, scope: null, loading: true, error: null });
    const scope = JSON.stringify([funnelId, text, prospectType, period]);
    const refresh = useCallback(() => setRefreshKey(value => value + 1), []);

    useEffect(() => {
        if (!funnelId) return;
        const controller = new AbortController();
        let active = true;
        let timeout;
        setState(previous => ({ ...previous, loading: true, error: null }));
        const timer = setTimeout(async () => {
            timeout = setTimeout(() => controller.abort(), 15000);
            try {
                const params = new URLSearchParams({ text, id_tipo: prospectType, period });
                const response = await fetchConToken(`crm/${funnelId}/metrics?${params}`, undefined, 'GET', { signal: controller.signal });
                const body = await response.json();
                if (!response.ok || !body.ok) throw new Error(body.msg || 'No se pudieron cargar los indicadores');
                if (!body.data?.open || !body.data?.closed || !body.data?.attention) throw new Error('Los indicadores no están disponibles');
                if (active) setState({ data: body.data, scope, loading: false, error: null });
            } catch (error) {
                if (active) setState({ data: null, scope, loading: false, error: error.name === 'AbortError' ? 'El servidor tardó demasiado. Intenta nuevamente.' : error.message });
            } finally { clearTimeout(timeout); }
        }, 250);
        return () => { active = false; clearTimeout(timer); clearTimeout(timeout); controller.abort(); };
    }, [funnelId, text, prospectType, revision, refreshKey, scope, period]);

    useEffect(() => {
        const refreshVisible = () => { if (document.visibilityState === 'visible') refresh(); };
        const interval = setInterval(refreshVisible, 60000);
        window.addEventListener('focus', refreshVisible);
        return () => { clearInterval(interval); window.removeEventListener('focus', refreshVisible); };
    }, [refresh]);

    return { data: state.scope === scope ? state.data : null, loading: state.loading || state.scope !== scope, error: state.scope === scope ? state.error : null, refresh };
}
